import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { TextValue } from 'elements/minute/sidebar/sidebarComponents/atomic/TextValue';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSection } from 'elements/minute/sidebar/sidebarSection/SidebarSection';
import { useDetailCRUD } from 'hooks/detail/useDetailCRUD';
import { useContext, useEffect, useState } from 'react';
import { IVariantIconV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';
interface Props {
    className?: string;
    marker: IVariantIconV2WorldMarker;
    disableEditText?: boolean;
}

export const VariantIconMarkerLabelSection = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const detailCRUD = useDetailCRUD(ctxEdit.map.worldMapId);
    const [storyTitle, setStoryTitle] = useState(null);

    function updateLabel(value: string) {
        ctxEdit.updateWorldMarkerData(props.marker.id, { text: value });
    }

    useEffect(() => {
        if (props.marker?.storyIds?.length !== 1) {
            return;
        }
        const readStory = async () => {
            const story = await detailCRUD.readDetail(props.marker.storyIds[0]);
            if (story.data?.moment?.header?.title) {
                setStoryTitle(story.data.moment.header.title);
            }
        };
        readStory();
    }, [props.marker.storyIds?.length]);

    return (
        <S_VariantIconMarkerLabelSection className={props.className}>
            <SidebarSection title={Localization.LABEL} icon={{ iconName: 'font' }} topBorder>
                <S_SidebarContent withTopPadding withHover>
                    <TextValue
                        value={props.marker.elementData.text}
                        disabled={props.disableEditText}
                        onChange={updateLabel}
                    />
                    <TextValue
                        width="50px"
                        value={props.marker.elementData.circleText}
                        onChange={(value) =>
                            ctxEdit.updateWorldMarkerData(props.marker.id, { circleText: value })
                        }
                    />
                </S_SidebarContent>
                {!props.disableEditText && (
                    <S_SidebarContent>
                        <ActionButton
                            text={Localization.LOAD_FROM_DETAIL}
                            icon={{ iconName: 'bullseye-pointer' }}
                            disabled={!Boolean(storyTitle)}
                            onClick={() => {
                                updateLabel(storyTitle);
                            }}
                        />
                    </S_SidebarContent>
                )}
            </SidebarSection>
        </S_VariantIconMarkerLabelSection>
    );
};

const S_VariantIconMarkerLabelSection = styled.div``;

const S_SidebarContent = styled(SidebarContent)`
    flex-direction: row;
    column-gap: 15px;
`;
